const MERCHANT_ORGANIZATION_UUID_QUERY_PARAM = 'merchant_organization_uuid';

export function getMerchantOrganizationUuidFromSearchParams(
    searchParams: URLSearchParams
): string | undefined {
    const rawValue: string | null = searchParams.get(MERCHANT_ORGANIZATION_UUID_QUERY_PARAM);
    if (rawValue === null || rawValue.trim().length === 0) {
        return undefined;
    }
    return rawValue;
}

export function appendMerchantOrganizationUuid(
    path: string,
    merchantOrganizationUuid: string | undefined
): string {
    if (merchantOrganizationUuid === undefined) {
        return path;
    }
    const url = new URL(path, 'https://anchorbase.invalid');
    url.searchParams.set(MERCHANT_ORGANIZATION_UUID_QUERY_PARAM, merchantOrganizationUuid);
    return `${url.pathname}${url.search}`;
}
